import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {httpCreateUser, HttpCreateUserPayload} from '@/features/users/http/users.http'
import {MUTATION_KEYS} from '@/queryClient'
import {AxiosError} from 'axios'
import {UserExtended} from '../types'
import {parseAxiosPromise} from '@/axiosInstance'
import {captureException} from '@sentry/react'

export const useCreateUser = (
    options: Omit<
        UseMutationOptions<UserExtended, AxiosError<{errors: {field: string; rule: string}[]}>, HttpCreateUserPayload>,
        'mutationFn'
    >
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.CREATE_USER],
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpCreateUser({
                    params: {responseType: 'extended'},
                    payload
                }),
                onZodError: captureException,
                responseShape: UserExtended
            })
    })
}
